import {
  type PriceListRevenueDepartment,
  RXDB_PRICE_LIST_REVENUE_DEPARTMENT_COLLECTION_NAME,
} from "$global-providers/rxdb-provider/collections/price-list-revenue-department";
import { useMemo } from "react";
import { useRxData } from "rxdb-hooks";

/**
 * Revenue departments as ID-backed select options, read from the local
 * rxdb replica (works offline, matches the V2 rxdb-backed billing stack).
 * The legacy `RevenueDepartmentSelectInput` queried Apollo and mapped to
 * name-valued options, which is why a manual selection could never be
 * persisted to `SyncableLineItem.revenueDepartmentId` — always select by
 * `id`.
 */
export const useRevenueDepartments = () => {
  const { result } = useRxData<PriceListRevenueDepartment>(
    RXDB_PRICE_LIST_REVENUE_DEPARTMENT_COLLECTION_NAME,
    (collection) => collection.find(),
    { json: true },
  );

  return useMemo(() => {
    const departments = [
      ...(result as unknown as PriceListRevenueDepartment[]),
    ].sort((a, b) => a.name.localeCompare(b.name));
    return {
      options: departments.map((dept) => ({
        value: dept.id,
        label: dept.name,
      })),
      nameById: new Map(departments.map((dept) => [dept.id, dept.name])),
    };
  }, [result]);
};
